import React from 'react'
import { PromiseButtonIcon, LocalizedText, download, useHandler } from 'labguard-cdk'
import { BookIcon } from 'src/components/common/icons'
import { AccountContext } from 'src/contexts'

export default function UserManualDownloadButton({ ...props }) {
  //const onClick = useHelpDownload

  const {
    account: { lang = {}, },
  } = AccountContext.use()

  function SelectHelpFile(id) {
    switch(id) {
      case '0':
        return '../../Help/English/WebServer/User Manual - 161150-1539 - A - en - LABGUARD Webserver_PUB.pdf';
      case '1':
        return '../../Help/Francais/WebServer/User Manual - 161150-1539 - A - fr - LABGUARD Webserver_PUB.pdf';
      case '2':
        return '../../Help/Deutsch/WebServer/User Manual - 161150-1539 - A - de - LABGUARD Webserver_PUB.pdf';
      case '3':
          return '../../Help/Italiano/WebServer/User Manual - 161150-1539 - A - it - LABGUARD Webserver_PUB.pdf';
      case '4':
        return '../../Help/Espanol/WebServer/User Manual - 161150-1539 - A - es - LABGUARD Webserver_PUB.pdf';
      case '5':
          return '../../Help/Portugues/WebServer/User Manual - 161150-1539 - A - pt - LABGUARD Webserver_PUB.pdf';
      default:
        return '../../Help/English/WebServer/User Manual - 161150-1539 - A - en - LABGUARD Webserver_PUB.pdf';
    }
  }
  const fileName = SelectHelpFile(lang.id)

  const onClick =  useHandler(() => download(fileName, 'UserManual.pdf'))
  return (
    <PromiseButtonIcon disabled={false} color="light" onClick={onClick} icon={BookIcon} {...props}>
      <LocalizedText id="WEB_GO_TO_DOCUMENTATION" />
    </PromiseButtonIcon>
  )
}

UserManualDownloadButton.propTypes = {}
